import React, { Fragment } from "react";
import { observer } from "mobx-react";
import { http } from "../../services/HttpInterceptor";
import { RouteComponentProps, Link, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { observable } from "mobx";
import InputForm from "../site/layout/InputForm";

interface IssuerProps extends RouteComponentProps {
  changeToggle(action?: boolean): void;
}

@observer
export default class Issuer extends React.Component<IssuerProps> {
  @observable private issuer: any;
  @observable private isLoaded = false;
  @observable private redirect = false;
  @observable private validationErrors: string[] = [];
  @observable private keyFile: File | null = null;
  @observable private cerFile: File | null = null;
  @observable private regimen_fiscal = [
    {
      id: "605",
      name: "605 - Sueldos y Salarios e Ingresos Asimilados a Salarios",
    },
    { id: "626", name: "626 - Régimen Simplificado de Confianza (RESICO)" },
    { id: "612", name: "612 - Actividades Empresariales y Profesionales" },
    { id: "606", name: "606 - Régimen de Arrendamiento" },
    {
      id: "625",
      name: "625 - Régimen de Actividades Empresariales con Ingresos a través de Plataformas Tecnológicas",
    },
    { id: "607", name: "607 - Régimen de Enajenación o Adquisición de Bienes" },
    { id: "608", name: "608 - Régimen de los Demás Ingresos" },
    { id: "611", name: "611 - Ingresos por Dividendos (Socios y Accionistas)" },
    { id: "614", name: "614 - Ingresos por Intereses" },
    { id: "615", name: "615 - Ingresos por Obtención de Premios" },
    { id: "621", name: "621 - Régimen de Incorporación Fiscal (RIF)" },
    { id: "616", name: "616 - Sin Obligaciones Fiscales" },
    { id: "601", name: "601 - Régimen General de Ley Personas Morales" },
    {
      id: "626",
      name: "626 - Régimen Simplificado de Confianza (RESICO) para Personas Morales",
    },
    { id: "603", name: "603 - Personas Morales con Fines no Lucrativos" },
    {
      id: "620",
      name: "620 - Sociedades Cooperativas de Producción que Optan por Diferir sus Ingresos",
    },
    {
      id: "622",
      name: "622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras",
    },
    { id: "623", name: "623 - Régimen Opcional para Grupos de Sociedades" },
    { id: "624", name: "624 - Coordinados" },
  ];
  @observable private activeOptions = [
    { id: "0", name: "Generar y timbrar cfdi" },
    { id: "1", name: "Solo generar cfdi" },
  ];

  componentDidMount() {
    this.props.changeToggle(true);
    this.init();
  }

  init = () => {
    http
      .get(`/api/payment/issuer/1`)
      .then((response) => {
        this.issuer = response.data;
        this.isLoaded = true;
      })
      .catch(() => {
        toast.error("Error cargando emisor");
      });
  };

  private handleChange = (event: any) => {
    const { name, value } = event.target;
    this.issuer[name] = value;
  };

  private uploadFile = (file: File, type: 'key' | 'cer') => {
    const formData = new FormData();
    formData.append(type, file);

    http
      .post(`/api/payment/upload_files`, formData)
      .then(() => {
        toast.success(`Archivo .${type} subido exitosamente`);
        if (type === 'key') {
          this.keyFile = null;
        } else {
          this.cerFile = null;
        }
      })
      .catch((error) => {
        toast.error(`Error subiendo archivo .${type}`);
        console.error(error);
      });
  };

  private handleKeyFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    if (file) {
      if (file.name.endsWith('.key')) {
        this.keyFile = file;
        this.uploadFile(file, 'key');
      } else {
        toast.error("Por favor, selecciona un archivo .key");
        event.target.value = ''; // Limpia el input
      }
    } else {
      this.keyFile = null;
    }
  };

  private handleCerFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    if (file) {
      if (file.name.endsWith('.cer')) {
        this.cerFile = file;
        this.uploadFile(file, 'cer');
      } else {
        toast.error("Por favor, selecciona un archivo .cer");
        event.target.value = ''; // Limpia el input
      }
    } else {
      this.cerFile = null;
    }
  };

  private setValidation = (value: boolean, name: string): void => {
    const error = this.validationErrors.indexOf(name);
    if (value && error === -1) {
      this.validationErrors.push(name);
    } else if (!value && error !== -1) {
      this.validationErrors.splice(error, 1);
    }
  };

  private onSubmit = (): void => {
    if (this.validationErrors.length > 0) {
      toast.error("Hay un error en tu formulario");
      return;
    }

    http
      .post(`/api/payment/update_issuer`, JSON.stringify(this.issuer))
      .then(() => {
        toast.success(`Emisor actualizado`);
        this.redirect = true;
      })
      .catch((error) => {
        if (Array.isArray(error)) {
          error.forEach((val) => {
            toast.error(val);
          });
        } else {
          toast.error(error);
        }
      });
  };

  render() {
    if (!this.isLoaded) {
      return null;
    }

    if (this.redirect) {
      return <Redirect to="/facturas" />;
    }

    return (
      <Fragment>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header card-header-rose card-header-text">
                <div className="card-text">
                  <h4 className="card-title">Datos de emisor</h4>
                </div>
              </div>
              <div className="card-body ">
                <div className="row">
                  <div className="col-sm-10"></div>
                  <div className="col-sm-2">
                    <Link to={`../facturas`}>
                      <button className="btn btn-danger btn-sm  pull-right">
                        <i className="material-icons">highlight_off</i>
                        <div className="ripple-container"></div>
                      </button>
                    </Link>
                  </div>
                </div>
                <InputForm
                  name="name"
                  label="Nombre"
                  value={this.issuer.name}
                  setValidation={this.setValidation}
                  required={false}
                  onChange={this.handleChange}
                  type="text"
                />
                <InputForm
                  name="rfc"
                  label="RFC"
                  value={this.issuer.rfc}
                  setValidation={this.setValidation}
                  required={false}
                  onChange={this.handleChange}
                  type="text"
                />
                <InputForm
                  name="regimen_fiscal"
                  label="Regimen Fiscal"
                  value={this.issuer.regimen_fiscal}
                  setValidation={this.setValidation}
                  required={false}
                  onChange={this.handleChange}
                  type="select"
                  options={this.regimen_fiscal}
                />
                <InputForm
                  name="factura_calle"
                  label="Calle"
                  value={this.issuer.factura_calle}
                  setValidation={this.setValidation}
                  required={false}
                  onChange={this.handleChange}
                  type="text"
                />
                <InputForm
                  name="factura_colonia"
                  label="Colonia"
                  value={this.issuer.factura_colonia}
                  setValidation={this.setValidation}
                  required={false}
                  onChange={this.handleChange}
                  type="text"
                />
                <InputForm
                  name="factura_interior"
                  label="Interior"
                  value={this.issuer.factura_interior}
                  setValidation={this.setValidation}
                  required={false}
                  onChange={this.handleChange}
                  type="text"
                />
                <InputForm
                  name="factura_exterior"
                  label="Exterior"
                  value={this.issuer.factura_exterior}
                  setValidation={this.setValidation}
                  required={false}
                  onChange={this.handleChange}
                  type="text"
                />
                <InputForm
                  name="factura_ciudad"
                  label="Ciudad"
                  value={this.issuer.factura_ciudad}
                  setValidation={this.setValidation}
                  required={false}
                  onChange={this.handleChange}
                  type="text"
                />
                <InputForm
                  name="factura_estado"
                  label="Estado"
                  value={this.issuer.factura_estado}
                  setValidation={this.setValidation}
                  required={false}
                  onChange={this.handleChange}
                  type="text"
                />
                <InputForm
                  name="factura_cp"
                  label="Codigo Postal"
                  value={this.issuer.factura_cp}
                  setValidation={this.setValidation}
                  required={false}
                  onChange={this.handleChange}
                  type="text"
                />
                <InputForm
                  name="solo_generar"
                  label="Opciones de Emisión(debug)"
                  value={this.issuer.solo_generar.toString()}
                  setValidation={this.setValidation}
                  required={true}
                  onChange={this.handleChange}
                  type="select"
                  options={this.activeOptions}
                />
                <div className="row">
                  <div className="col-md-6">
                    <label>Subir archivo .key</label>
                    <input
                      type="file"
                      accept=".key"
                      onChange={(e) => this.handleKeyFileChange(e)}
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-6">
                    <label>Subir archivo .cer</label>
                    <input
                      type="file"
                      accept=".cer"
                      onChange={(e) => this.handleCerFileChange(e)}
                      className="form-control"
                    />
                  </div>
                </div>
                <button
                  onClick={this.onSubmit}
                  type="submit"
                  className="btn btn-primary pull-right"
                >
                  Actualizar Emisor
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
